import { IParameterRepository } from "domain/contracts/parameter.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { Parameter } from "domain/entities/parameter";

class ParameterRepository implements IParameterRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/parameterType/${id}`);
    return response.data;
  }

  async create(input: Parameter): Promise<Message<Parameter>> {
    const response = await httpClient.post(`/parameterType`, { data: input });
    return response.data;
  }

  async update(input: Parameter): Promise<Message<boolean>> {
    const response = await httpClient.put(`/parameterType/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: BaseInputFilter): Promise<Message<Parameter[]>> {
    const response = await httpClient.get(`/parameterType`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Parameter>> {
    const response = await httpClient.get(`/parameterType/${id}`);
    return response.data;
  }
}

export default new ParameterRepository();
